import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Layouts
import RootLayout from './layouts/RootLayout';

// Utilities
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Collaborate from './pages/Collaborate';
import Story from './pages/Story';
import NotFound from './pages/NotFound';

// Import global styles
import './styles/globals.css';

/**
 * Main Application Component
 *
 * @component
 * @description Root component managing routing for the static marketing site.
 * All pages are public; RootLayout wraps them with the Navbar, Footer, and
 * XP taskbar chrome.
 */
function App() {
  return (
    <Router basename={process.env.PUBLIC_URL || '/'}>
      <ScrollToTop />
      <Routes>
        <Route element={<RootLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/story" element={<Story />} />
          <Route path="/collaborations" element={<Collaborate />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* 404 catch-all — BSOD */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
